import Paragraph from "../Utils/Paragraph.styled";
import Stack from "../Utils/Stack.styled";
import {
  PlaylistCardContainer,
  PlaylistImage,
  PlaylistImageContainer,
} from "./PlaylistDetailCard.styled";

const PlaylistDetailCard = ({ image, title }) => {
  return (
    <PlaylistCardContainer>
      <Stack
        direction="row"
        width="100%"
        height="100%"
        gap="16"
        alignItems="center"
      >
        <PlaylistImageContainer>
          <PlaylistImage src={image} />
        </PlaylistImageContainer>
        <Paragraph>{title}</Paragraph>
      </Stack>
    </PlaylistCardContainer>
  );
};

export default PlaylistDetailCard;
